<template>
  <span class="d-inline-flex align-items-center gap-2" dir="rtl" aria-live="off">
    <span>{{ countdown.days }} روز</span>
    <span>{{ countdown.hours }} ساعت</span>
    <span>{{ countdown.minutes }} دقیقه</span>
    <span>{{ countdown.seconds }} ثانیه</span>
  </span>
</template>

<script>
export default {
  name: 'DepositPeriodCountdown',
  props: {
    target: { type: String, required: true }
  },
  emits: ['expired'],
  data() {
    return { clock: Date.now(), interval: null, expired: false }
  },
  computed: {
    countdown() {
      const end = new Date(this.target).getTime()
      const seconds = Number.isFinite(end) ? Math.max(0, Math.floor((end - this.clock) / 1000)) : 0
      return {
        days: Math.floor(seconds / 86400),
        hours: Math.floor((seconds % 86400) / 3600),
        minutes: Math.floor((seconds % 3600) / 60),
        seconds: seconds % 60
      }
    }
  },
  watch: {
    target() {
      this.expired = false
      this.tick()
    }
  },
  mounted() {
    this.tick()
    this.interval = setInterval(this.tick, 1000)
  },
  beforeUnmount() {
    clearInterval(this.interval)
  },
  methods: {
    tick() {
      this.clock = Date.now()
      const end = new Date(this.target).getTime()
      if (Number.isFinite(end) && end <= this.clock && !this.expired) {
        this.expired = true
        this.$emit('expired')
      }
    }
  }
}
</script>
